export const mutations = {
  allIdpsData(state, allIdpsData) {
    state.allIdpsData = allIdpsData
  }
}
